export default __webpack_public_path__ + "static/media/myjourney-bluetree-fruitflower.2d565e63.svg";